import { Suspense } from "react";
import { SubAppSkeleton } from "shell/components/SubAppSkeleton";
import { useTranslation } from "react-i18next";
import { MarketplaceWrapper } from "./app";

// Inner — triggers the "marketplace" namespace lazy load; suspends until ready
const MarketplaceAppInner = () => {
  useTranslation("marketplace");
  return <MarketplaceWrapper data-sentry-element="MarketplaceWrapper" data-sentry-component="MarketplaceAppInner" data-sentry-source-file="index.tsx" />;
};

// Outer (exported) — owns the Suspense boundary for the sub-app subtree
const MarketplaceApp = () => <Suspense fallback={<SubAppSkeleton />} data-sentry-element="Suspense" data-sentry-component="MarketplaceApp" data-sentry-source-file="index.tsx">
    <MarketplaceAppInner data-sentry-element="MarketplaceAppInner" data-sentry-source-file="index.tsx" />
  </Suspense>;
export default MarketplaceApp;